import { useFormik } from 'formik';
import React from 'react';
import Modal from 'react-awesome-modal';
import { useSelector, useDispatch } from 'react-redux';

import SimpleButton from '../../components/buttons/simpleButton';
import MaskedInput from '../../components/inputs/maskedInput';
import { Creators as messageActions } from '../../store/ducks/messageSauce';
import {
  ModalContainer,
  Title,
  Descripition,
  ButtonsContainer,
} from './styles';

export default function TimerModalOdometerModal() {
  const dispatch = useDispatch();
  const visible = useSelector(state => state.messageState.modal === 'orimeter');
  const device = useSelector(state => state.deviceState.device);
  const formik = useFormik({
    initialValues: {
      orimeter: '',
    },
    validate: value => {
      const err = {};
      if (!value.orimeter) err.odometer = 'Campo obrigatório!';
      return err;
    },
    onSubmit: data => {
      const orimeterSplit = data.orimeter.split('.');
      const orimeterSum = orimeterSplit[0] * 60 + orimeterSplit[1] * 6;
      if (device.model === 'SUNTECH' && device.type === 'ST4315U') {
        window.location.href = `sms://${device.phone}?body=CMD;${device.imei};05;05;${orimeterSum}`;
      } else if (device.model === 'SUNTECH') {
        window.location.href = `sms://${device.phone}?body=ST300CMD;${device.imei};02;SetHMeter=${orimeterSum}`;
      } else if (device.model === 'VITANA') {
        window.location.href = `sms://${device.phone}?body=Comando não suportado`;
      }
    },
  });
  return (
    <Modal
      visible={visible}
      onClickAway={() => dispatch(messageActions.setEnableModal(false))}
      height="180"
      width="300"
      effect="fadeInUp"
    >
      <ModalContainer onSubmit={formik.handleSubmit}>
        <Title>Horímetro</Title>
        <Descripition>
          <MaskedInput
            placeholder="Digite o odômetro"
            mask="99999.9"
            name="orimeter"
            type="tel"
            onChange={formik.handleChange}
            value={formik.values.orimeter}
            error={!!(formik.touched.orimeter && formik.errors.orimeter)}
          />
        </Descripition>
        <ButtonsContainer>
          <SimpleButton
            text="Cancelar"
            bg="#ff4e4e"
            color="#eee"
            onClick={() => dispatch(messageActions.setEnableModal(false))}
          />
          <SimpleButton
            type="subbmit"
            text="Enviar"
            bg="#01659e"
            color="#eee"
          />
        </ButtonsContainer>
      </ModalContainer>
    </Modal>
  );
}
